export default "__VITE_ASSET__7429ea3f__"